import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App, { isPublicPath } from "@/App";

// Set theme + standalone classes before first paint (no purple/red flash).
document.documentElement.classList.toggle("hq-theme", !isPublicPath(window.location.pathname));
if (window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches) {
  document.documentElement.classList.add("hq-standalone");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
